export class LanguageModel {
    value: string;
    label: string;
}
